import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.regexp.split";
import _values from "lodash/values";
import _last from "lodash/last";
import _isString from "lodash/isString";
import _isNil from "lodash/isNil";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { FORMATS, VALUE_SIZES } from '@nerdwallet/marketplace/constants/drivers';
import { formatValue } from '@nerdwallet/marketplace/utils/format';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Tooltip, Type } from '@nerdwallet/currency';
import styles from './quick-facts.module.less';
import { isServer } from './mappings/utils';
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/utils/format` directly.
 */

export { formatValue };

var QuickFactValue = function QuickFactValue(_ref) {
  var analytics = _ref.analytics,
      enableAnalytics = _ref.enableAnalytics,
      quickFact = _ref.quickFact,
      showNAForEmptyValue = _ref.showNAForEmptyValue;
  useDeprecatedPropsWarning({
    component: 'QuickFactValue',
    deprecatedProps: [{
      version: '5.5.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics prop instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });

  if (_isNil(quickFact.value) || quickFact.value === '') {
    return showNAForEmptyValue ? /*#__PURE__*/React.createElement(Type, null, "N/A") : null;
  }

  var formattedValue = quickFact.valueFormat === FORMATS.UNFORMATTED ? quickFact.value : formatValue(quickFact.value, quickFact.valueFormat);
  var tooltip = quickFact.valueTooltip && /*#__PURE__*/React.createElement("span", {
    className: styles.tooltipPreserveWhitespace
  }, /*#__PURE__*/React.createElement(Tooltip, {
    id: quickFact.id,
    className: styles.tooltip,
    content: /*#__PURE__*/React.createElement("span", {
      className: styles.tooltipContent
    }, !isServer() && quickFact.valueTooltip),
    title: "More information about ".concat(quickFact.label),
    placement: "bottom",
    analytics: (enableAnalytics || analytics) && _objectSpread({
      entityNamePrefix: "quick_fact_value_tooltip"
    }, analytics)
  })); // To ensure that the tooltip does not wrap to the next line,
  // wrap it in a nowrap span with the last word of the value.
  // Unfortunately, we can only do this is if the value is a string.

  var value;

  if (tooltip && _isString(formattedValue)) {
    var valueWords = formattedValue.split('');
    value = /*#__PURE__*/React.createElement(Fragment, null, valueWords.slice(0, valueWords.length - 1).join(''), /*#__PURE__*/React.createElement("span", {
      className: styles.tooltipWrapper
    }, _last(valueWords), tooltip));
  } else {
    value = /*#__PURE__*/React.createElement(Fragment, null, formattedValue, tooltip);
  }

  return /*#__PURE__*/React.createElement(Fragment, null, quickFact.valueFormat === FORMATS.UNFORMATTED ? value : /*#__PURE__*/React.createElement(Type, {
    className: styles[quickFact.valueSize || VALUE_SIZES.LARGE]
  }, value), quickFact.description && /*#__PURE__*/React.createElement(Type, {
    size: 1,
    color: "neutral-darker",
    className: styles.description
  }, quickFact.description));
};

QuickFactValue.propTypes = {
  /** Analytics Props */
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    parentPositionAttributes: PropTypes.shape({
      payload: PropTypes.shape({
        sectionName: PropTypes.string,
        parentImpressionId: PropTypes.string,
        sectionPosition: PropTypes.number
      })
    })
  }),

  /**
   * Flag to enable bedrock analytics
   */
  enableAnalytics: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    impressionId: PropTypes.string
  })]),

  /** Quick fact to display */
  quickFact: PropTypes.shape({
    /** The unique id for this particular quick fact */
    id: PropTypes.string.isRequired,

    /** The quick fact label text */
    label: PropTypes.node,

    /** The popover text to be associated with the label */
    labelTooltip: PropTypes.node,

    /** The quick fact value */
    value: PropTypes.node,

    /** Specifies how the value should be formatted.
     Supports 'currency', 'currencyWithCents', 'percent', 'string', and 'unformatted'.
     Defaults to 'string'. */
    valueFormat: PropTypes.oneOf(_values(FORMATS)),

    /** The popover text to be associated with the value */
    valueTooltip: PropTypes.node,

    /** The type size of the value. Supports 'large', 'medium', and 'small'.
     Defaults to 'large'. */
    valueSize: PropTypes.oneOf(_values(VALUE_SIZES)),

    /** The quick fact description */
    description: PropTypes.node
  }).isRequired,

  /** If true, an empty value will be display as 'N/A'. Otherwise, nothing will be rendered.
   Defaults to false. */
  showNAForEmptyValue: PropTypes.bool
};
QuickFactValue.defaultProps = {
  analytics: {},
  showNAForEmptyValue: false
};
export default QuickFactValue;